import { Spinner } from "@cjdev-internal/visual-stack-x/Spinner";
import { Stack } from "@cjdev-internal/visual-stack-x/Stack";

export const SpinnerPage = () => (
  <Stack align="center" justify="center">
    <Spinner />
  </Stack>
);
